export default __webpack_public_path__ + "img/img_ann-6cb218f61d04a0a643e90bdafabca126.jpg";